import React, { useEffect, useContext } from 'react';
import {
  Box,
  Grid,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Loader } from '@alumni-ventures-group/react-shared/lib/components';
import useStyles from '../styles';
import { PlanContext } from '../../context/PlanContext';
import { CardLabelTypography } from '../common/perFundAllocationStrategyCardStyle';
import ToggleIconWithInput from '../common/ToggleIconWithInput';
import { FundType } from '../../constants';

const SyndicationPlan = ({ setNextDisabled }) => {
  const classes = useStyles();
  const {
    plan,
    userPortfolio,
    planningConfig,
  } = useContext(PlanContext);

  const getAllocation = (fundType) => {
    const allocation = plan?.fundTypeAllocations?.find(
      (candidateAllocation) => candidateAllocation.fundType === fundType,
    );
    return allocation?.amount && parseFloat(allocation.amount) > 0
      ? parseFloat(allocation.amount)
      : '';
  };

  const isReady = Boolean(
    userPortfolio
    && Object.keys(userPortfolio).length > 0
    && planningConfig?.syndicationPlan,
  );

  useEffect(() => {
    setNextDisabled(!isReady);
  }, [isReady, setNextDisabled]);

  if (!userPortfolio || !planningConfig?.syndicationPlan) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Loader />
      </Box>
    );
  }

  return (
    <Box className={classes.content}>
      <Typography
        variant="h1ExtraLarge"
        component="h1"
        style={{ color: '#191919' }}
      >
        {planningConfig?.syndicationPlan?.title}
      </Typography>
      <Typography
        variant="body2Inter"
        component="div"
        style={{ color: '#797979', padding: 15 }}
        dangerouslySetInnerHTML={{
          __html: planningConfig?.syndicationPlan?.subtitle?.richtext || '',
        }}
      />
      <Grid container xs={12} sm={10} className={classes.card}>
        <Grid item xs={12} lg={6}>
          <CardLabelTypography
            variant="h3"
            component="label"
            style={{ padding: '25px 5px' }}
          >
            {planningConfig?.syndicationPlan?.syndicationAllocationTitle}
          </CardLabelTypography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <ToggleIconWithInput
            amount={getAllocation(FundType.SYNDICATION)}
            disabled
            isChecked
            centered
          />
        </Grid>
      </Grid>
      <Typography
        variant="field"
        component="div"
        style={{
          maxWidth: '83.33%',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        }}
        dangerouslySetInnerHTML={{
          __html: planningConfig?.syndicationPlan?.bodyCopy?.richtext || '',
        }}
      />
    </Box>
  );
};

SyndicationPlan.propTypes = {
  setNextDisabled: PropTypes.func.isRequired,
};

export default SyndicationPlan;
